import FormControlsEnabled from './form-controls-enabled-component';

import './form-controls-enabled.scss';

const MODULE_NAME = 'app.common.form-controls-enabled';
const module = angular.module(MODULE_NAME, [])
    .directive(FormControlsEnabled.DIRECTIVE_NAME, FormControlsEnabled);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/form-controls-enabled/form-controls-enabled-module.js